import script from "./PersonPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonPage.vue?vue&type=script&setup=true&lang=js"

import "./PersonPage.vue?vue&type=style&index=0&id=5176fd37&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5176fd37"]])

export default __exports__